import { trackPromise } from 'react-promise-tracker';
import axios, { AxiosResponse } from 'axios';
import apiInstance from 'interceptors/axiosInterceptor';

export const getAuthAfip = async () => {
	const data = JSON.stringify({
		CertFile:
			'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',
		CertPwd: 'ccpmsecret'
	});

	const config = {
		method: 'post',
		url: '/afip/Auth/SolicitarAuthToken?solicitante=30672393333&servicio=ws_sr_padron_a4',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		data: data
	};

	const datos: Promise<void | AxiosResponse> = axios(config).catch((error) => {
		return error;
	});
	const res = await datos;

	localStorage.setItem('afipToken', res?.data.Token);
	localStorage.setItem('afipSign', res?.data.Sign);
	return res?.data;
};

export const getAfipUser = async (user: string, solicitante = '30672393333'): Promise<any> => {
	let Token = localStorage.getItem('afipToken') || '';
	let Sign = localStorage.getItem('afipSign') || '';

	if (Token.trim().length === 0 || Sign.trim().length === 0) {
		const auth = await getAuthAfip();
		Token = auth.Token;
		Sign = auth.Sign;
	}

	const data = JSON.stringify({
		Sign: Sign,
		Token: Token,
		cuitRepresentada: 30672393333,
		idContribuyente: user
	});

	const config = {
		method: 'post',
		url: `/afip/PadronFiscalN4/ObtenerPersona?solicitante=${solicitante}`,
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		data: data
	};

	const datos = trackPromise(axios(config), 'altaPaso1')
		.then((res) => {
			return res;
		})
		.catch((error) => {
			if (error.response.data.Message.includes('token ha expirado')) {
				localStorage.removeItem('afipToken');
				localStorage.removeItem('afipSign');
				return getAfipUser(user, solicitante);
			}
			if (error.code === 'ERR_NETWORK') {
				localStorage.removeItem('afipToken');
				localStorage.removeItem('afipSign');
				return 'Error en los servicios de AFIP';
			}
			return error.response.data.Message;
		});

	return datos;
};

export const getUserAfip = async (documentId: string) => {
	const response = await apiInstance.get('/afip-data', { params: { id_person: documentId } });
	return response.data as {
		data_source: string;
		id: number;
		id_person: string;
		name: string;
		last_name: string;
		business_name: string;
		is_dni: true;
		fiscal_address: {
			zip_code: string;
			additional_data: string;
			province_description: string;
			address: string;
			id_province: 0;
			id_province_specified: true;
			town: string;
			additional_data_type: string;
			domicile_type: string;
		};
		has_error_afip?: boolean;
	};
};
